export default __webpack_public_path__ + "static/media/ReactNative.f05109b9.jpg";